import ComplianceStatusButton from "./compliance-status-button";
export default ComplianceStatusButton;